import {
  CORAL,
  CYAN,
  GREY,
  LAVENDER,
  MINT,
  ORANGE,
  SLATE,
  YELLOW_BRIGHT,
} from './colours';

export const DEFAULT_COLOUR_PICKER_COLOURS = [
  LAVENDER,
  SLATE,
  CYAN,
  MINT,
  YELLOW_BRIGHT,
  ORANGE,
  CORAL,
  GREY,
] as const;

export const DEFAULT_PIPELINE_STAGE_COLOUR = GREY;

export const ACCOUNT_PIPELINES_LIMIT = 50;

export const MAX_PIPELINE_TITLE_LENGTH = 255;
export const MAX_PIPELINE_STAGE_TITLE_LENGTH = 255;
export const MAX_PIPELINE_STAGES = 50;

export const PIPELINE_STAGE_PROJECTS_DEFAULT_SORT = {
  by: 'LATEST_ACTIVITY_AT',
  direction: 'DESC',
} as const;
